import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class appTitlePwa_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `
             <!-- ko if: !isLinkDisabled() -->
             <a data-bind="attr: { href: url }"><span data-bind="text: title"></span></a>
             <!-- /ko -->
            `;
    }

    protected getTemplateName(): string{
        return "appTitle-template";
    }

    protected getMainElementType(): string{
        return "h1";
    }

    protected getMainElementClasses(): Array<string>{
        return ["site-logo"];
    }

    protected buildViewModel(): any{

        return {
            title: ko.observable("no title")
            ,isLinkDisabled: ko.observable(false)
            ,url: ko.observable("/mobile/analytics/live-dashboard/")
        };
    }

    public setTitle(title: string){
        this.getTemplateViewModel().title(title);
    }

    public setIsLinkDisabled(isLinkDisabled: boolean){
        this.getTemplateViewModel().isLinkDisabled(isLinkDisabled);
    }

    public setUrl(url: string){
        this.getTemplateViewModel().url(url);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/appTitlePwa_template.ts